import axiosInstance from '../../../config/axiosInstance';
const  JobDocumentService = {
    async GetAllJobDocuments(redirectCallback,IssueID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetAllJobDocumenet?IssueID=${IssueID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJobDocument(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/DeleteJobDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default JobDocumentService;